/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import * as EmailValidator from 'email-validator';
import AuthLayout from '../Layouts/Authlayout';
import {
  PLACEHOLDER_EMAIL,
  PLACEHOLDER_PASSWORD,
  LABEL_FORGOT_PASSWORD,
  BTN_LOGIN,
  ERR_EMAIL,
  ERR_PASSWORD_REQUIRED,
  ERR_EMAIL_INVALID,
  ERR_INVALID_CREDENTIALS
} from '../../constants/constant';
import { InputAdornment, TextField } from '@mui/material';
import '../Styles/login.css';
import { useLogin } from '../../hooks/useLogin';
//@ts-ignore
import { HugeiconsIcon } from '@hugeicons/react';
//@ts-ignore
import {Alert02StrokeStandard} from '@hugeicons-pro/core-stroke-standard';
import GradientButton from '../MUICustomButton/GradientButton';


interface LoginFormInputs {
  username: string;
  password: string;
}

const validationSchema = Yup.object().shape({
  username: Yup.string()
    .required(ERR_EMAIL)
    .email(ERR_EMAIL_INVALID)
    .test(
      'is-valid-email',
      ERR_EMAIL_INVALID,
      (value) => value === '' || EmailValidator.validate(value),
    ),
  password: Yup.string().required(ERR_PASSWORD_REQUIRED),
});

export default function LoginForm(): JSX.Element {
  const { login, isLoading, error } = useLogin();
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState<string>("");
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormInputs>({
    resolver: yupResolver(validationSchema),
    mode: 'onSubmit',
  });

  const onSubmit = async (data: LoginFormInputs): Promise<void> => {
    await login(data.username, data.password);
  };

  useEffect(() => {
    if (error !== '' && error !== null) {
      setMessage(ERR_INVALID_CREDENTIALS);
    }
  }, [error]);

  return (
    <AuthLayout>
      <div className="login-content w-full">
        {message !== "" && (
          <div className="w-full mb-[15px] border border-ED4B52 bg-errorbg rounded-lg h-[45px] text-center pt-[10px] pb-[13px] text-14 font-semibold text-primary">
            <span>{message}</span>
          </div>
        )}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            void handleSubmit(onSubmit)(e);
          }}
        >
          <div className="mb-[30px]">
            <Controller
              name="username"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Email address"
                  autoComplete="off"
                  placeholder={PLACEHOLDER_EMAIL}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img
                          src="/assets/images/input-email.svg"
                          alt="email"
                          width={22}
                          height={20}
                        />
                      </InputAdornment>
                    ),
                  }}
                  error={Boolean(errors.username)}
                  helperText={
                    errors.username ? (
                      <span className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeMedium MuiFormHelperText-contained css-1d3jg1r pl-3" style={{ display: 'flex', alignItems: 'center'}}>
                        <HugeiconsIcon
                        icon={Alert02StrokeStandard}
                        size={12} 
                        color="#ed4b52"
                        strokeWidth={0.5}
                        style={{ marginRight: '4px'}}
                          />  
                        {errors.username.message}
                      </span>
                    ) : null
                  }
                />
              )}
            />
          </div>
          <div className="mb-[10px]">
            <Controller
              name="password"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  label="Password"
                  autoComplete="off"
                  type={showPassword ? 'text' : 'password'}
                  placeholder={PLACEHOLDER_PASSWORD}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img
                          src="/assets/images/input-password.svg"
                          alt="password"
                          width={22}
                          height={22}
                        />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <img
                          src={
                            showPassword
                              ? '/assets/images/show-password.svg'
                              : '/assets/images/close-password.svg'
                          }
                          onClick={() => setShowPassword(!showPassword)}
                          alt="toggle-password"
                          width={22}
                          height={20}
                          className="cursor-pointer"
                        />
                      </InputAdornment>
                    ),
                  }}
                  error={Boolean(errors.password)}
                  helperText={
                    errors.password ? (
                      <p className="MuiFormHelperText-root Mui-error MuiFormHelperText-sizeMedium MuiFormHelperText-contained css-1wc848c-MuiFormHelperText-root pl-3">
                        <span style={{ display: 'flex', alignItems: 'center' }}>
                        <HugeiconsIcon
                        icon={Alert02StrokeStandard}
                        size={12} 
                        color="#ed4b52"
                        strokeWidth={0.5}
                        style={{ marginRight: '4px'}}
                          />  
                          {errors.password.message}
                        </span>
                      </p>
                    ) : null
                  }
                />
              )}
            />
          </div>
          <div className="flex justify-end content-center mb-[25px]">
            <div>
              <a
                href="/forgot-password"
                className="text-muted text-14 underline hover:text-primary"
              >
                {LABEL_FORGOT_PASSWORD}
              </a>
            </div>
          </div>
          {/* <button
            type="submit"
            disabled={isLoading}
            className="btn btn-block bg-gradient-to-b border-0 from-[#ED4B52] to-[#D6242C] h-[45px] text-14 capitalize focus-visible:outline-none rounded-50 font-semibold hover:from-[#D6242C] hover:to-[#ED4B52] text-white disabled:btn-primary disabled:opacity-100 disabled:text-white"
          >
            {!isLoading ? (
              BTN_LOGIN
            ) : (
              <span className="loading loading-spinner loading-xs text-white" />
            )}
          </button> */}
          <GradientButton type='submit' color='red' width='100%' height='45px' onClick={() => console.log('Button clicked')} disabled={isLoading} >{!isLoading ? BTN_LOGIN : <span className="loading loading-spinner loading-xs text-white" />}</GradientButton>
        </form>
      </div>
    </AuthLayout>
  );
}
